import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MUIButton from '@mui/material/Button';
import MUILoading from '@mui/material/CircularProgress';
import React from 'react';

interface IButton {
  text: string;
  loading?: boolean;
  onClick?: (e: any) => void;
  variant?: 'contained' | 'outlined' | 'text';
  px?: number;
  py?: number;
  styles?: any;
  [x: string]: any;
  children?: any;
  disabled?: boolean;
}

const Button: React.FC<IButton> = ({
  text,
  loading,
  onClick,
  px,
  py = 11,
  variant = 'contained',
  styles = {},
  children,
  disabled,
  ...rest
}) => {
  const { breakpoints } = useTheme();
  const matches = useMediaQuery(breakpoints.down('md'));

  const paddingX = px ? px : matches ? 23 : 75;

  return (
    <MUIButton
      sx={{
        fontSize: 16,
        lineHeight: 1.375,
        padding: `${py}px ${paddingX}px`,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        letterSpacing: 'initial',
        minWidth: 120,
        whiteSpace: 'nowrap',
        ...styles,
      }}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {loading && <MUILoading size={22} color="inherit" />}
      {!loading && text}
      {children && !loading && children}
    </MUIButton>
  );
};

export default Button;
